<template>
    <UtilPanelContent>
<!--        <v-overlay v-model="showOverlay"></v-overlay>-->
        <template v-slot:utils>
            <div v-if="stShowIndex" class="utils-box">
                <Index @close-index="showIndex" class="elevation-11 border-radius-1" />
            </div>
            <div v-if="stShowSettings" class="utils-box">
                <Settings
                    :isBookFunctionality="true"
                    @close-settings="showSettings"
                    class="elevation-11 border-radius-1"
                />
            </div>
            <div v-if="stShowQuestions" class="utils-box">
                <Questions @close-question="showQuestions" class="elevation-11 border-radius-1" />
            </div>
            <div v-if="stShowHighlights" class="utils-box">
                <Highlight @close-highlight="showHighlights" class="elevation-11 border-radius-1" />
            </div>
            <div v-if="stShowMusic" class="utils-box">
                <Music
                    :isBookFunctionality="true"
                    @close-music="showMusic"
                    class="elevation-11 border-radius-1"
                />
            </div>
            <div v-if="stShowDictionary" class="utils-box">
                <Dictionary
                    @close-dictionary="openDictionary"
                    v-if="stShowDictionary"
                    class="elevation-11 border-radius-1"
                />
            </div>
            <div v-if="stShowNotes" class="utils-box" transition="slide-x-transition">
                <StickyNotes @close-note="showNotes" class="elevation-11 border-radius-1" />
            </div>
            <div v-show="stShowReadaloud" class="utils-box" transition="slide-x-transition">
                <ReadAloud @close-reading="showReadaloud" class="elevation-11 border-radius-1" />
            </div>
        </template>
        <div
            :class="
                'mx-auto border-radius-1 transition-all util-bar ' +
                (showTexts ? 'util-bar-text' : 'util-bar-non-text')
            "
        >
            <div
                class="d-flex flex-column justify-center align-center util-bar-border content-shadow w-100"
                @mouseover="showTexts = true"
                @mouseleave="showTexts = false"
            >
                <div class="border-top w-100">
                    <v-btn
                        data-cy="utilsPanel-showIndexModal-button"
                        text
                        block
                        class="w-100 ma-0 py-6 d-flex justify-end align-center utils-panel-button"
                        @click="showIndex"
                    >
                        <div
                            class="d-flex flex-column justify-center align-end option--primary ml-15 mr-2 transition-all"
                            v-if="showTexts"
                        >
                            <span class="text-capitalize">{{ texts.indexTxt.text }} </span>
                            <span class="font-size-9 font-weight-regular opacity-9 text-capitalize"
                                >{{ texts.indexTxt.trl }}
                            </span>
                        </div>
                        <img class="reading-util-icon" :src="indexImg" alt="index image icon"
                    /></v-btn>
                    <v-btn
                        data-cy="utilsPanels-settings-button"
                        text
                        block
                        class="w-100 ma-0 py-6 d-flex justify-end align-center utils-panel-button"
                        @click="showSettings"
                        ><div
                            class="d-flex flex-column justify-center align-end option--primary ml-15 mr-2"
                            v-if="showTexts"
                        >
                            <span class="text-capitalize">{{ texts.settingTxt.text }} </span>
                            <span class="font-size-9 font-weight-regular opacity-9 text-capitalize"
                                >{{ texts.settingTxt.trl }}
                            </span>
                        </div>
                        <img class="reading-util-icon" :src="settingImg"
                    /></v-btn>
                    <!-- <v-btn
                        data-cy="utilsPanels-questions-button"
                        text
                        block
                        :class="
                            'w-100 ma-0 py-6 d-flex justify-end align-center ' +
                            (hasQuestion ? 'animated infinite bounce delay-2s' : '')
                        "
                        @click="showQuestions"
                        id="btn-question"
                        ><div
                            class="d-flex flex-column justify-center align-end option--primary ml-15 mr-2"
                            v-if="showTexts"
                        >
                            <span class="text-capitalize">{{ texts.questionsTxt.text }} </span>
                            <span class="font-size-9 font-weight-regular opacity-9 text-capitalize"
                                >{{ texts.questionsTxt.trl }}
                            </span>
                        </div>
                        <img
                            class="reading-util-icon"
                            :src="questionsImg"
                            alt="question image icon"
                    /></v-btn> -->
                </div>
                <div class="bottom-radius border-bottom w-100">
                    <v-btn
                        data-cy="utilsPanel-showHighlights-button"
                        block
                        color="transparent"
                        elevation="0"
                        class="w-100 ma-0 border-radius-0 py-6 d-flex justify-end align-center utils-panel-button"
                        @click="showHighlights"
                        ><div
                            class="d-flex flex-column justify-center align-end option--white ml-15 mr-2"
                            v-if="showTexts"
                        >
                            <span class="text-capitalize">{{ texts.highlightingsTxt.text }} </span>
                            <span class="font-size-9 font-weight-regular opacity-9 text-capitalize"
                                >{{ texts.highlightingsTxt.trl }}
                            </span>
                        </div>
                        <img class="reading-util-icon" :src="highlightingsImg"
                    /></v-btn>
                    <v-btn
                        data-cy="utilsPanels-notes-button"
                        block
                        color="transparent"
                        elevation="0"
                        class="w-100 ma-0 border-radius-0 py-6 d-flex justify-end align-center utils-panel-button"
                        @click="showNotes"
                        ><div
                            class="d-flex flex-column justify-center align-end option--white ml-15 mr-2"
                            v-if="showTexts"
                        >
                            <span class="text-lowercase first-uppercase">{{ texts.notesTxt.text }} </span>
                            <span class="text-lowercase first-uppercase font-size-9 font-weight-regular opacity-9">
                                My notes
                            </span>
                        </div>
                        <img class="reading-util-icon" :src="notesImg"
                    /></v-btn>
                    <v-btn
                        data-cy="utilsPanels-dictionary-button"
                        block
                        color="transparent"
                        elevation="0"
                        class="w-100 ma-0 border-radius-0 py-6 d-flex justify-end align-center utils-panel-button"
                        @click="openDictionary"
                        ><div
                            class="d-flex flex-column justify-center align-end option--white ml-15 mr-2"
                            v-if="showTexts"
                        >
                            <span class="text-capitalize">{{ texts.dictionaryTxt.text }} </span>
                            <span class="font-size-9 font-weight-regular opacity-9 text-capitalize"
                                >{{ texts.dictionaryTxt.trl }}
                            </span>
                        </div>
                        <img class="reading-util-icon" :src="dictionaryImg"
                    /></v-btn>
                    <v-btn
                        data-cy="utilsPanels-narrator-button"
                        block
                        color="transparent"
                        elevation="0"
                        class="w-100 ma-0 border-radius-0 py-6 d-flex justify-end align-center utils-panel-button"
                        @click="showReadaloud"
                        ><div
                            class="d-flex flex-column justify-center align-end option--white ml-15 mr-2"
                            v-if="showTexts"
                        >
                            <span class="text-capitalize">{{ texts.readaloudTxt.text }} </span>
                            <span class="font-size-9 font-weight-regular opacity-9 text-capitalize"
                                >{{ texts.readaloudTxt.trl }}
                            </span>
                        </div>
                        <img class="reading-util-icon" :src="readaloudImg"
                    /></v-btn>
                    <v-btn
                        data-cy="utilsPanels-music-button"
                        block
                        color="transparent"
                        elevation="0"
                        class="w-100 ma-0 border-radius-0 py-6 d-flex justify-end align-center utils-panel-button"
                        @click="showMusic"
                        ><div
                            class="d-flex flex-column justify-center align-end option--white ml-15 mr-2"
                            v-if="showTexts"
                        >
                            <span class="text-capitalize">{{ texts.musicTxt.text }} </span>
                            <span class="font-size-9 font-weight-regular opacity-9 text-capitalize"
                                >{{ texts.musicTxt.trl }}
                            </span>
                        </div>
                        <img class="reading-util-icon" :src="musicImg"
                    /></v-btn>
                </div>
            </div>
        </div>
    </UtilPanelContent>
</template>
<script>
/* eslint-disable global-require */
import { mapActions, mapState } from 'vuex'

import Music from '@/components/core/utils/Music.vue'
import ReadAloud from '@/components/core/utils/ReadAloud.vue'
import UtilPanelContent from '@/components/core/utils/UtilPanelContent.vue'
import Dictionary from '@/components/core/utils/Dictionary.vue'
import Settings from '@/components/core/utils/Settings.vue'
import Index from './bookUtils/Index.vue'
import Questions from './bookUtils/Questions.vue'
import Highlight from './bookUtils/Highlight.vue'
import StickyNotes from './bookUtils/StickyNotes.vue'

export default {
    components: {
        Index,
        Settings,
        Questions,
        Highlight,
        Music,
        Dictionary,
        StickyNotes,
        ReadAloud,
        UtilPanelContent,
    },
    data() {
        return {
            showTexts: false,
            indexImg: require('@/assets/img/icons/new-reading/index-purple.svg'),
            settingImg: require('@/assets/img/icons/new-reading/settings-purple.svg'),
            questionsImg: require('@/assets/img/icons/reading/3-questions.svg'),
            highlightingsImg: require('@/assets/img/icons/new-reading/highlighting-white.svg'),
            notesImg: require('@/assets/img/icons/new-reading/notes-white.svg'),
            dictionaryImg: require('@/assets/img/icons/new-reading/dictionary-white.svg'),
            readaloudImg: require('@/assets/img/icons/new-reading/read-aloud-white.svg'),
            musicImg: require('@/assets/img/icons/new-reading/music-white.svg'),
        }
    },
    methods: {
        ...mapActions('bookReading', [
            'showIndex',
            'showSettings',
            'showQuestions',
            'showHighlights',
            'showMusic',
            'showDictionary',
            'showNotes',
            'setDictionaryMode',
            'showReadaloud',
        ]),
        openDictionary() {
            this.setDictionaryMode('manual')
            this.showDictionary()
        },
    },
    computed: {
        ...mapState({
            stShowIndex: (state) => state.bookReading.showIndex,
            stShowSettings: (state) => state.bookReading.showSettings,
            stShowQuestions: (state) => state.bookReading.showQuestions,
            stShowHighlights: (state) => state.bookReading.showHighlights,
            stShowMusic: (state) => state.bookReading.showMusic,
            stShowDictionary: (state) => state.bookReading.showDictionary,
            stShowNotes: (state) => state.bookReading.showNotes,
            stShowReadaloud: (state) => state.bookReading.showReadaloud,
            hasQuestion: (state) => state.bookReading.hasQuestion,
        }),
        showOverlay(){
            return this.stShowIndex || this.stShowSettings || this.stShowQuestions
                || this.stShowHighlights || this.stShowMusic || this.stShowDictionary
                || this.stShowNotes || this.stShowReadaloud
        },
        texts() {
            return {
                indexTxt: {
                    text: this.$t('bookReading.index'),
                    trl: this.$i18n.locale === 'es' ? 'Index' : 'Índice',
                },
                settingTxt: {
                    text: this.$t('bookReading.settings'),
                    trl: this.$i18n.locale === 'es' ? 'Settings' : 'Ajustes',
                },
                questionsTxt: {
                    text: this.$t('bookReading.question'),
                    trl: this.$i18n.locale === 'es' ? 'Questions' : 'Preguntas',
                },
                highlightingsTxt: {
                    text: this.$t('bookReading.marker'),
                    trl: this.$i18n.locale === 'es' ? 'Highlighting' : 'Marcadores',
                },
                notesTxt: {
                    text: this.$t('bookReading.notes'),
                    trl: this.$i18n.locale === 'es' ? 'Notes' : 'Notas',
                },
                dictionaryTxt: {
                    text: this.$t('bookReading.dictionary'),
                    trl: this.$i18n.locale === 'es' ? 'Dictionary' : 'Diccionario',
                },
                readaloudTxt: {
                    text: this.$t('bookReading.storyletter'),
                    trl: this.$i18n.locale === 'es' ? 'Read Aloud' : 'Narrador',
                },
                musicTxt: {
                    text: this.$t('bookReading.music'),
                    trl: this.$i18n.locale === 'es' ? 'Music' : 'Música',
                },
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.bg-purple {
    background: #514585;
    border: 1.5px solid #514585;
}
.option--primary {
    color: #514585;
}
.option--white {
    color: white;
}
.util-bar {
    z-index: 5;
    position: fixed;
}

.util-bar-text {
    width: 12.5em !important;
}

.util-bar-non-text {
    width: 3.5em;
}
.util-bar-border {
    border-radius: 1vh;
}

.bottom-radius {
    border-radius: 0 0 1vh 1vh !important;
}

.border-top {
    border: 1.5px solid #514585 !important;
    border-radius: 1vh 1vh 0 0 !important;
    background: white;
}
.border-bottom {
    border: 1.5px solid #514585 !important;
    background: #514585;
}

.content-shadow {
    box-shadow: 0 6px 7px -4px rgba(0, 0, 0, 0.2), 0 11px 15px 1px rgba(0, 0, 0, 0.14),
        0 4px 20px 3px rgba(0, 0, 0, 0.12) !important;
}

.reading-util-icon {
    height: 32px;
    width: 32px;
}

.util-bar {
    right: 1em;
    top: 1rem;
}
.v-btn.utils-panel-button{
    padding: 0 10px;
}
.utils-box{
    margin-right: 56px;
}
.first-uppercase{
    &::first-letter{
        text-transform: uppercase;
    }
} 
</style>
